import React from "react";
import { View, StyleSheet, Image, ScrollView } from "react-native";
import colors from "../../config/colors";
import NtTextInput from "../../components/NtTextInput";
import {
  authenticate,
  authenticateRequestCode,
  authenticateVerifyCode,
} from "../../api/auth";
import { showToast } from "../../common/utils/ControllerUtils";
import BaseController from "../../common/base/BaseController";
import NtRootPageContainer from "../../root/components/NtRootPageContainer";
import NtText from "../../components/NtText";
import NtTouchableEffect from "../../components/NtTouchableEffect";
import NtMaterialIcon from "../../components/NtMaterialIcon";
import NtActivityIndicator from "../../components/NtActivityIndicator";
import NtInputCode from "../components/NtInputCode";
import Logger from "../../common/utils/Logger";
import NtFormButtonNext from "../../components/NtFormButtonNext";
import NtImageBackground from "../../marketing/components/general/NtImageBackground";
import NtSectionButton from "../../marketing/components/general/NtSectionButton";
import routes from "../../navigation/routes";

class AuthCodeController extends BaseController {
  state = {
    code: "",
    loading: false,
    requestingCode: false,
  };

  componentDidMount() {
    Logger("props", this.props, this.props.route.params);
  }

  handleAuthCodeVerify = async () => {
    this.setState({ loading: true });

    const response = await authenticateVerifyCode(
      atob(decodeURIComponent(this.props.route?.params?.token)),
      this.state.code
    );

    Logger("Finished verifying the code", response);

    this.setState({ loading: false });

    if (response.ok) {
      if (response.data?.user?.type != "reseller") {
        showToast(
          "Oops...",
          "This account does not have access to the portal."
        );
        return;
      }

      this.context.updateUser({
        ...this.context.user,
        user: response.data.user,
        authenticated: true,
      });

      setTimeout(() => {
        this.props.navigation.navigate(routes.dashboard);
      }, 500);
      // this.handleExtensionFetch();
    } else {
      showToast("Oops...", "Invalid code, Please try again.");
    }
  };

  handleExtensionFetch = async () => {
    this.setState({ loading: true });

    const response = await fetchExtensionByNumber(
      this.props.route?.params?.extension,
      this.context.user?.environment?.domain
    );
    if (response.ok) {
      this.setState({ code: "" });

      const params = this.parseParams(response.data?.extensions);
      this.context.updateUser({
        ...this.context.user,
        ...params,
        authenticated: true,
      });

      setTimeout(() => {
        navigationRef.current.navigate(routes.dashboard);
      }, 500);
    } else {
      showToast("Oops...", "Unable to process request. Please try again.");
    }

    this.setState({ loading: false });
  };

  handleAuthCodeRequest = async () => {
    this.setState({ requestingCode: true });

    const response = await authenticateRequestCode(
      atob(decodeURIComponent(this.props.route?.params?.token))
    );
    if (response.ok) {
      showToast(
        "Success",
        "Successfully requested a new code. Please check your email."
      );
    } else {
      showToast(
        "Oops...",
        "Unable to request a code. Please try again later.",
        "error"
      );
    }

    this.setState({ requestingCode: false });
  };

  isFieldsRequired = () => {
    return this.state.code && this.state.code.length == 6;
  };

  renderResendLink = (containerStyle) => {
    return (
      <View
        style={[
          {
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          },
          containerStyle,
        ]}
      >
        <NtText style={{ fontSize: 14, fontWeight: "500", color: "white" }}>
          Did not get the code?
        </NtText>

        <NtSectionButton
          containerStyle={{ marginLeft: 10 }}
          title="Resend Code"
          color={"white"}
          onPress={() => {
            this.handleAuthCodeRequest();
          }}
        />

        {this.state.requestingCode && (
          <NtActivityIndicator
            containerStyle={{ marginLeft: 10 }}
            size="small"
            color={colors.nettalkBlue}
          />
        )}
      </View>
    );
  };

  render() {
    return (
      <View style={styles.container}>
        <NtImageBackground
          containerStyle={{ height: "100%" }}
          image={require("../../assets/images/marketing/ff8be5d5b3ab6249a5739ba42b1b268c10d1acda.png")}
        />

        <View
          style={{
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <View
            style={{
              minWidth: 400,
            }}
          >
            <NtText
              style={{
                textAlign: "center",
                fontSize: 28,
                fontWeight: "500",
                color: "white",
              }}
            >
              VALIDATE CODE
            </NtText>

            <NtText
              style={{
                textAlign: "center",
                fontSize: 14,
                fontWeight: "500",
                marginTop: 8,
                color: "white",
              }}
            >
              Please enter the code received via email
            </NtText>

            {this.renderResendLink({ marginTop: 10 })}

            <View style={{ marginTop: 15 }}>
              <NtInputCode
                containerStyle={{ marginTop: 20, marginBottom: 10 }}
                cellNotEmptyColor="green"
                cellBackgroundColor="rgba(255, 255, 255, 0.1)"
                cellActiveBackgroundColor="rgba(255, 255, 255, 0.6)"
                onTextChange={(text) => {
                  this.setState({ code: text });
                }}
              />
            </View>

            <View
              style={{
                alignItems: "center",
                flexDirection: "row",
                marginTop: 30,
                width: "100%",
              }}
            >
              <Image
                style={[styles.protectedImage, { marginRight: 15 }]}
                source={require("../../assets/images/nt_protect_logo.png")}
              />
              <NtSectionButton
                containerStyle={{
                  paddingTop: 6,
                  paddingBottom: 6,
                  flex: 1,
                }}
                loading={this.state.loading}
                textStyle={{ fontSize: 13 }}
                title="Validate Code"
                color={"white"}
                onPress={
                  this.isFieldsRequired()
                    ? () => {
                        this.handleAuthCodeVerify();
                      }
                    : null
                }
              />
            </View>
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  input: {
    paddingLeft: 10,
    paddingRight: 10,
    width: "100%",
    height: 45,
    backgroundColor: "white",
    borderRadius: 12,
  },
  title: {
    fontSize: 40,
    fontWeight: "bold",
    color: "white",
  },
  subtitle: {
    fontSize: 16,
    fontWeight: "600",
    color: "white",
  },
  info: {
    textAlign: "center",
    color: "white",
  },
  protectedImage: {
    height: 40,
    width: 40,
    resizeMode: "contain",
  },
});

export default AuthCodeController;
